// extracted by mini-css-extract-plugin
export default {"ModeratorInvitationListItem":"bef_a big_a big_r big_j","ModeratorInvitationListItem__left":"bef_b big_a big_j","ModeratorInvitationListItem__note":"bef_c big_fo"};